import React from "react";
import { Typography, Row, Collapse } from "antd";
import dayjs from "dayjs";

const { Text } = Typography;

const ShareholderInfoCard = ({ data }) => {
  return (
    <Collapse
      accordion
      defaultActiveKey={["1"]}
      items={[
        {
          key: "1",
          label: <Typography.Text strong>Thông tin cổ đông</Typography.Text>,
          children: (
            <>
              <Row justify="space-between">
                <Text strong type="secondary">
                  Họ tên
                </Text>
                <Text strong>{data?.hoTen}</Text>
              </Row>

              <Row justify="space-between" style={{ marginTop: 12 }}>
                <Text strong type="secondary">
                  Số điện thoại
                </Text>
                <Text strong>{data?.phone}</Text>
              </Row>

              <Row justify="space-between" style={{ marginTop: 12 }}>
                <Text strong type="secondary">
                  Căn cước công dân
                </Text>
                <Text strong>{data?.cccd}</Text>
              </Row>

              <Row justify="space-between" style={{ marginTop: 12 }}>
                <Text strong type="secondary">
                  Địa chỉ
                </Text>
                <Text strong>{data?.diaChi}</Text>
              </Row>

              <Row justify="space-between" style={{ marginTop: 12 }}>
                <Text strong type="secondary">
                  Số cổ phần
                </Text>
                <Text strong style={{ color: "#0B3C6F" }}>
                  {(data?.soCoPhan ?? 0).toLocaleString("vi-VN")}
                </Text>
              </Row>

              <Row justify="space-between" style={{ marginTop: 12 }}>
                <Text strong type="secondary">
                  Trạng thái check-in
                </Text>
                <Text
                  strong
                  style={{
                    color: data?.trangThaiCheckin2026 === 1 ? "green" : "red",
                  }}
                >
                  {data?.trangThaiCheckin2026 === 1
                    ? "Đã Check-In"
                    : "Chưa Check-In"}
                </Text>
              </Row>

              <Row justify="space-between" style={{ marginTop: 12 }}>
                <Text strong type="secondary">
                  Thời gian check-in
                </Text>
                <Text strong>
                  {data?.timeCheckIn &&
                    dayjs(data?.timeCheckIn).format("DD/MM/YYYY HH:mm")}
                </Text>
              </Row>

              {data?.uyQuyen && (
                <>
                  <Row justify="space-between" style={{ marginTop: 12 }}>
                    <Text strong type="secondary">
                      Họ tên (Ủy quyền)
                    </Text>
                    <Text strong>{data?.hoTenUyQuyen}</Text>
                  </Row>

                  <Row justify="space-between" style={{ marginTop: 12 }}>
                    <Text strong type="secondary">
                      Số điện thoại (Ủy quyền)
                    </Text>
                    <Text strong>{data?.sdtUyQuyen}</Text>
                  </Row>
                  <Row justify="space-between" style={{ marginTop: 12 }}>
                    <Text strong type="secondary">
                      Trạng thái check-in (Ủy quyền)
                    </Text>
                    <Text
                      strong
                      style={{
                        color:
                          data?.trangThaiUyQuenCheckIn2026 === 1
                            ? "green"
                            : "red",
                      }}
                    >
                      {data?.trangThaiUyQuenCheckIn2026 === 1
                        ? "Đã Check-In"
                        : "Chưa Check-In"}
                    </Text>
                  </Row>

                  <Row justify="space-between" style={{ marginTop: 12 }}>
                    <Text strong type="secondary">
                      Thời gian check-in (Ủy quyền)
                    </Text>
                    <Text strong>
                      {data?.timeCheckInUyQuyen &&
                        dayjs(data?.timeCheckInUyQuyen).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                    </Text>
                  </Row>
                </>
              )}
            </>
          ),
        },
      ]}
    />
  );
};

export default ShareholderInfoCard;
